import { StyleSheet } from 'aphrodite';
import { brandPrimaryText, success } from '../../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	container: {
		background: '#D8FFB0',
		borderRadius: 10,
		boxShadow: '0px 0px 6px rgba(139, 139, 139, 0.1)',
		display: 'flex',
		justifyContent: 'space-around',
		width: '100%',
	},
	moarButton: {
		background: '#AFE07D',
		borderRadius: 10,
		height: 56,
		margin: '20px 0px',
		textAlign: 'center',
		width: 150,
	},
	moarText: {
		color: '#046CB6',
		fontSize: 18,
		fontWeight: 800,
		letterSpacing: 1.8,
		padding: '0px 20px',
		textDecoration: 'underline',
		textTransform: 'uppercase',
	},
	monthlyPercent: {
		color: brandPrimaryText,
		fontSize: 72,
		fontWeight: 900,
	},
	monthName: {
		color: brandPrimaryText,
		fontSize: 14,
		fontWeight: 900,
		textTransform: 'uppercase',
	},
	right: {
		padding: '14px 30px',
	},
	svgContainer: {
		transform: 'translate3d(-20px, 0, 0)',
	},
	title: {
		color: success,
		fontSize: 30,
		fontWeight: 800,
		letterSpacing: '3px',
		padding: 30,
		textTransform: 'uppercase',
	},
});
